document.addEventListener("DOMContentLoaded", function () {

  // Check if the current page is a collection page
  const isCollectionPage = document.body.dataset.template === "collection";

  if (isCollectionPage) {
    const buttons = document.querySelectorAll(".custom-btn");
    const productGrid = document.getElementById("CollectionProductGrid");
    const localStorageKey = "activeButtonId";

    if (!buttons.length || !productGrid) {
      return;
    }

    const setActiveButton = (buttonId) => {
      buttons.forEach((button) => button.classList.toggle("active", button.id === buttonId));
      productGrid.className = buttonId === "c-product-btn" ? "c-product-btn" : "c-lifestyle-btn";
      localStorage.setItem(localStorageKey, buttonId);
    };

    buttons.forEach((button) => button.addEventListener("click", () => setActiveButton(button.id)));

    const savedButtonId = localStorage.getItem(localStorageKey) || "c-product-btn";
    setActiveButton(savedButtonId);
  }

  let observer;
  let reviewContainer;
  const MAX_RETRIES = 3;
  let retryCount = 0;

  // Enhanced logger
function log(message, data = null) {
  console.log(`[Review Images] ${message}`, data || '');
}

  function warn(message, error = null) {
    console.warn(`[Review Images] ${message}`, error || '');
  }

  async function fetchProductData(productHandle) {
    try {
      log(`Fetching product data for handle: ${productHandle}`);
      const response = await fetch(`/products/${productHandle}.json`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      log(`Successfully fetched product data for ${productHandle}`);
      return data.product;
    } catch (error) {
      warn(`Error fetching product data for ${productHandle}: ${error.message}`);
      return null;
    }
  }

  async function addProductImagesToReviews(parent = document) {
    try {
      const reviews = parent.querySelectorAll(".jdgm-rev:not([data-image-loaded])");
      log(`Found ${reviews.length} unprocessed reviews in parent`, parent);

      for (const [index, review] of reviews.entries()) {
        log(`Processing review ${index + 1}/${reviews.length}`);
        
        let productUrl = review.getAttribute("data-product-url") || 
          review.querySelector(".jdgm-rev__prod-link")?.href?.split("#")[0];

        if (!productUrl) {
          warn("Skipping review - no product URL found", review);
          continue;
        }

        // Improved handle extraction with URL normalization
        const handleMatch = productUrl.match(/products\/([^\/?#]+)/i);
        if (!handleMatch) {
          warn("Invalid product URL format", productUrl);
          continue;
        }
        
        let productHandle = handleMatch[1];
        log(`Extracted product handle: ${productHandle}`);

        let productData = await fetchProductData(productHandle);
        let usedRedirect = false;

        // Handle redirects
        if (!productData) {
          log(`Trying redirect resolution for ${productUrl}`);
          try {
            const response = await fetch(productUrl, { redirect: "follow" });
            
            if (response.redirected) {
              const redirectedUrl = new URL(response.url);
              log(`Redirected to: ${redirectedUrl.href}`);
              
              const newHandleMatch = redirectedUrl.pathname.match(/products\/([^\/]+)/i);
              if (newHandleMatch) {
                productHandle = newHandleMatch[1];
                log(`New handle from redirect: ${productHandle}`);
                productData = await fetchProductData(productHandle);
                usedRedirect = true;
              }
            }
          } catch (error) {
            warn("Redirect handling failed", error);
          }
        }

        if (productData?.images?.length) {
          try {
            const productImageUrl = productData.images[0].src;
            log(`Creating image elements for ${productImageUrl}`);

            // Create DOM elements
            const wrapper = document.createElement("div");
            wrapper.className = "jdgm-rev-wrapper";

            const imageColumn = document.createElement("div");
            imageColumn.className = "jdgm-rev-image-column";

            const link = document.createElement("a");
            link.className = "jdgm-rev-product-link";
            link.href = productUrl;
            link.target = "_blank";

            const img = document.createElement("img");
            img.className = "jdgm-rev-product-img";
            img.src = productImageUrl;
            img.alt = "Product Image";
            
            // Add image error handling
            img.onerror = () => warn("Image failed to load", productImageUrl);

            // Build structure
            link.appendChild(img);
            imageColumn.appendChild(link);
            
            const contentColumn = document.createElement("div");
            contentColumn.className = "jdgm-rev-content-column";
            
            while (review.firstChild) {
              contentColumn.appendChild(review.firstChild);
            }

            wrapper.append(imageColumn, contentColumn);
            review.appendChild(wrapper);
            review.setAttribute("data-image-loaded", "true");
            log("Successfully added product image");

          } catch (domError) {
            warn("DOM manipulation error", domError);
          }
        } else {
          warn("Product data missing or no images available", productData);
        }
      }
    } catch (error) {
      warn("Critical error in addProductImagesToReviews", error);
    }
  }

  // Improved observer setup
  function initObserver() {
    reviewContainer = document.querySelector(".jdgm-rev-widg__reviews");
    
    if (reviewContainer && !observer) {
      observer = new MutationObserver(mutations => {
        log(`Processing ${mutations.length} mutations`);
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches(".jdgm-rev")) {
              log("New review node detected", node);
              addProductImagesToReviews(node);
            }
          });
        });
      });

      observer.observe(reviewContainer, {
        childList: true,
        subtree: true,
        attributes: false
      });
      log("MutationObserver initialized");
    }
  }

  // Enhanced load more handling
  document.addEventListener("click", async (event) => {
    if (event.target.closest(".jdgm-paginate__load-more")) {
      log("Load More button clicked");
      retryCount = 0;
      
      let retryDelay = 1000;

async function checkForReviews() {
  const newReviews = document.querySelectorAll(".jdgm-rev:not([data-image-loaded])");

  if (newReviews.length > 0) {
    log(`Processing ${newReviews.length} new reviews after load`);
    await addProductImagesToReviews(document.body);
    return;
  }

  if (retryCount >= MAX_RETRIES) {
    return;
  }

  retryCount++;
  log(`Retry check ${retryCount}/${MAX_RETRIES}`);

  setTimeout(checkForReviews, retryDelay);
}

setTimeout(checkForReviews, retryDelay);
    }
  });

  // Initial setup
  initObserver();
  addProductImagesToReviews();

  // Safety check for container changes
  setTimeout(initObserver, 5000);
});

// Laboo 2026: make the product review carousel scroll cleanly after restyling.
(function () {
  function initLabooReviewSliders() {
    document.querySelectorAll(".product-bottom-reviews--carousel").forEach(function (section) {
      if (section.dataset.labooReviewSliderReady === "true") {
        return;
      }

      var scroller = section.querySelector(".jdgm-carousel__item-container");
      var track = section.querySelector(".jdgm-carousel__item-wrapper");
      var prev = section.querySelector(".jdgm-carousel__left-arrow");
      var next = section.querySelector(".jdgm-carousel__right-arrow");

      if (!scroller || !track || !prev || !next) {
        return;
      }

      section.dataset.labooReviewSliderReady = "true";

      function getStep() {
        var firstItem = section.querySelector(".jdgm-carousel-item");
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0);

        if (firstItem) {
          return firstItem.getBoundingClientRect().width + (Number.isNaN(gap) ? 0 : gap);
        }

        return scroller.clientWidth * 0.8;
      }

      function scrollReviews(direction, event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }

        scroller.scrollBy({
          left: direction * getStep(),
          behavior: "smooth"
        });
      }

      prev.addEventListener("click", scrollReviews.bind(null, -1), true);
      next.addEventListener("click", scrollReviews.bind(null, 1), true);
    });
  }

  document.addEventListener("DOMContentLoaded", initLabooReviewSliders);
  window.addEventListener("load", initLabooReviewSliders);
  setTimeout(initLabooReviewSliders, 1200);
  setTimeout(initLabooReviewSliders, 3200);
})();

// Laboo 2026: apply Shopify locale strings to asynchronously rendered review and recently viewed content.
(function () {
  function applyLabooLocaleStrings() {
    const labels = window.LabooI18n || {};
    const reviewLabels = labels.reviews || {};
    const recentlyViewedLabels = labels.recentlyViewed || {};

    document.querySelectorAll('body.template-product .product-bottom-reviews--carousel .product-review-eyebrow').forEach(function (element) {
      if (reviewLabels.eyebrow) element.textContent = reviewLabels.eyebrow;
    });

    document.querySelectorAll('body.template-product .product-bottom-reviews--carousel .product-review-section-heading h2').forEach(function (element) {
      if (reviewLabels.heading) element.textContent = reviewLabels.heading;
    });

    document.querySelectorAll('body.template-product .product-bottom-reviews--carousel .jdgm-carousel-item__product-title').forEach(function (element) {
      if (reviewLabels.purchased) element.dataset.labooPurchasedLabel = reviewLabels.purchased;
    });

    document.querySelectorAll('body.template-product .product-bottom-reviews--carousel .jdgm-carousel-item__timestamp').forEach(function (element) {
      const source = (element.getAttribute('data-time') || '').trim();
      const locale = document.documentElement.lang || 'en';
      const marker = source + '|' + locale;

      if (!source || element.dataset.labooLocalizedDate === marker) return;

      const match = source.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (!match) return;

      const month = Number(match[1]);
      const day = Number(match[2]);
      const year = Number(match[3]);
      const date = new Date(Date.UTC(year, month - 1, day));

      if (
        date.getUTCFullYear() !== year ||
        date.getUTCMonth() !== month - 1 ||
        date.getUTCDate() !== day
      ) return;

      element.textContent = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
      }).format(date);

      element.dataset.labooLocalizedDate = marker;
    });

    document.querySelectorAll('.rvp-wrapper').forEach(function (wrapper) {
      if (recentlyViewedLabels.eyebrow) wrapper.dataset.labooEyebrow = recentlyViewedLabels.eyebrow;

      const heading = wrapper.querySelector('.rvp-heading');
      if (heading && recentlyViewedLabels.heading) heading.textContent = recentlyViewedLabels.heading;
    });
  }

  document.addEventListener('DOMContentLoaded', applyLabooLocaleStrings);
  document.addEventListener('shopify:section:load', applyLabooLocaleStrings);
  window.addEventListener('load', applyLabooLocaleStrings);
  window.setTimeout(applyLabooLocaleStrings, 1200);
  window.setTimeout(applyLabooLocaleStrings, 3200);
})();

// Laboo 2026: add a real review CTA to the custom Judge.me carousel heading.
(function () {
  function openWriteReview(event) {
    const reviewTargets = Array.from(document.querySelectorAll('#judgeme_product_reviews'));
    const target = reviewTargets.find(function (element) {
      return element.offsetParent !== null;
    }) || reviewTargets[0];

    if (!target) {
      return;
    }

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    window.setTimeout(function () {
      const writeButton = target.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-link-container a, [data-write-review]');

      if (writeButton) {
        writeButton.click();
      }
    }, 550);
  }

  function addReviewButtons() {
    document.querySelectorAll('body.template-product .product-bottom-reviews--carousel .product-review-section-heading').forEach(function (heading) {
      if (heading.querySelector('.product-review-write-button')) {
        return;
      }

      const button = document.createElement('a');
      button.className = 'product-review-write-button';
      button.href = '#judgeme_product_reviews';
      button.textContent = (window.LabooI18n && window.LabooI18n.reviews && window.LabooI18n.reviews.write) || 'Write a review';
      button.addEventListener('click', openWriteReview);
      heading.appendChild(button);
    });
  }

  document.addEventListener('DOMContentLoaded', addReviewButtons);
  document.addEventListener('shopify:section:load', addReviewButtons);
  window.addEventListener('load', addReviewButtons);
})();

// Laboo 2026: Wild Nutrition-style product gallery progress bar.
(function () {
  function initProductGalleryProgress() {
    document.querySelectorAll('body.template-product product-page .p-media-wrap.product-gallery').forEach(function (gallery) {
      var slider = gallery.querySelector('css-slider');
      var container = gallery.querySelector('.css-slider-container');
      var items = Array.from(gallery.querySelectorAll('.product-gallery-item'));

      if (!slider || !container || items.length < 2) {
        return;
      }

      var progress = gallery.querySelector('.laboo-product-gallery-scrollbar');
      if (!progress) {
        progress = document.createElement('div');
        progress.className = 'laboo-product-gallery-scrollbar';
        progress.setAttribute('aria-hidden', 'true');
        progress.innerHTML = '<div class="laboo-product-gallery-scrollbar__drag"></div>';
        slider.insertAdjacentElement('afterend', progress);
      }

      progress.style.setProperty('--laboo-gallery-count', String(items.length));

      // 1 Nov 2026 (Tony): "View in room" on the main photo replaces the Size guide button. It opens the same room / size viewer
      // (data-size-guide-open, laboo-pdp-at-home.js), so it is only added where that viewer is showing.
      var viewer = document.querySelector('[data-lpah-sv]');
      var roomBtn = slider.querySelector('.laboo-view-room');
      if (viewer && !viewer.hidden && !roomBtn) {
        var lang = (document.documentElement.lang || 'en').slice(0, 2);
        var label = { de: 'Im Raum ansehen', fr: 'Voir dans la pièce', es: 'Ver en la habitación', it: 'Vedi nella stanza', sv: 'Visa i rummet' }[lang] || 'View in room';
        roomBtn = document.createElement('button');
        roomBtn.type = 'button';
        roomBtn.className = 'laboo-view-room';
        roomBtn.setAttribute('data-size-guide-open', '');
        roomBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10.5 12 4l9 6.5"/><path d="M5 9.5V20h14V9.5"/><rect x="9" y="12" width="6" height="5"/></svg><span></span>';
        roomBtn.lastChild.textContent = label;
        slider.appendChild(roomBtn);
      } else if (roomBtn && (!viewer || viewer.hidden)) {
        roomBtn.remove();
      }

      // 1 Nov 2026 (Tony, GoodMood style): phones show small dots on the photo instead of the arrows + this bar (laboo-product-layout.css)
      var dots = slider.querySelector('.laboo-gallery-dots');
      if (!dots) {
        dots = document.createElement('div');
        dots.className = 'laboo-gallery-dots';
        dots.setAttribute('aria-hidden', 'true');
        dots.innerHTML = items.map(function () { return '<span></span>'; }).join('');
        slider.appendChild(dots);
      }

      function getActiveIndex() {
        var active = gallery.querySelector('.product-gallery-item.css-slide-active');
        if (active && active.dataset.index !== undefined) {
          return Number(active.dataset.index) || 0;
        }

        if (typeof slider.index === 'number') {
          return slider.index;
        }

        if (container.scrollWidth > container.clientWidth) {
          var maxScroll = container.scrollWidth - container.clientWidth;
          return Math.round((container.scrollLeft / maxScroll) * (items.length - 1));
        }

        return 0;
      }

      function updateProgress() {
        var index = Math.max(0, Math.min(items.length - 1, getActiveIndex()));
        progress.style.setProperty('--laboo-gallery-index', String(index));
        dots.querySelectorAll('span').forEach(function (dot, i) { dot.classList.toggle('is-on', i === index); });
        // first + last photos are the main pictures: smaller, more see-through View in room so it covers less of the print (Tony)
        var roomPill = slider.querySelector('.laboo-view-room');
        if (roomPill) roomPill.classList.toggle('is-subtle', index === 0 || index === items.length - 1);
      }

      // phones: the thumbnail row follows the outlined (active) thumbnail as the photos are swiped (GoodMood). The theme moves
      // .active once the photo has settled, so watch that rather than the gallery update (which fires before it).
      var thumbRow = gallery.querySelector('.product-gallery__thumbnails-holder');
      if (thumbRow && !thumbRow.__labooFollow) {
        thumbRow.__labooFollow = true;
        var followTimer = 0;
        new MutationObserver(function () {
          clearTimeout(followTimer);
          followTimer = setTimeout(function () {
            if (!window.matchMedia('(max-width: 767px)').matches) return;
            var on = thumbRow.querySelector('.thumbnail.active');
            if (!on) return;
            var hr = thumbRow.getBoundingClientRect(), tr = on.getBoundingClientRect();
            if (tr.left >= hr.left && tr.right <= hr.right) return;
            var to = thumbRow.scrollLeft + tr.left - hr.left - (hr.width - tr.width) / 2;
            thumbRow.scrollTo({ left: to, behavior: 'smooth' });
            // if the smooth scroll did not happen (some browsers skip it), jump there
            setTimeout(function () {
              var r1 = thumbRow.getBoundingClientRect(), t1 = on.getBoundingClientRect();
              if (t1.left < r1.left || t1.right > r1.right) thumbRow.scrollTo({ left: to, behavior: 'instant' });
            }, 400);
          }, 60);
        }).observe(thumbRow, { attributes: true, subtree: true, attributeFilter: ['class'] });
      }

      if (progress.dataset.labooProgressReady !== 'true') {
        progress.dataset.labooProgressReady = 'true';
        slider.addEventListener('change', updateProgress);
        slider.addEventListener('navigation', function () {
          window.requestAnimationFrame(updateProgress);
        });

        container.addEventListener('scroll', function () {
          window.requestAnimationFrame(updateProgress);
        }, { passive: true });

        gallery.querySelectorAll('.product-gallery__thumbnails .thumbnail, .css-slider-button').forEach(function (control) {
          control.addEventListener('click', function () {
            window.setTimeout(updateProgress, 80);
          });
        });

        new MutationObserver(updateProgress).observe(container, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class']
        });
      }

      updateProgress();
    });
  }

  document.addEventListener('DOMContentLoaded', initProductGalleryProgress);
  document.addEventListener('shopify:section:load', initProductGalleryProgress);
  window.addEventListener('load', initProductGalleryProgress);
  window.setTimeout(initProductGalleryProgress, 800);
  window.setTimeout(initProductGalleryProgress, 2400);
})();

// Laboo 2026: desktop product thumbnail strip chevron.
(function () {
  var thumbnailSelector = 'body.template-product product-page .product-gallery__thumbnails';

  function isDesktop() {
    return window.matchMedia('(min-width: 769px)').matches;
  }

  function getThumbnailWraps(scope) {
    if (scope.matches && scope.matches(thumbnailSelector)) {
      return [scope];
    }

    return Array.from(scope.querySelectorAll(thumbnailSelector));
  }

  function initThumbnailChevron(root) {
    var scope = root || document;

    getThumbnailWraps(scope).forEach(function (wrap) {
      var holder = wrap.querySelector('.product-gallery__thumbnails-holder');
      if (!holder) {
        return;
      }

      var button = wrap.querySelector('.laboo-thumbnail-next');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'laboo-thumbnail-next';
        button.setAttribute('aria-label', 'Show more product images');
        wrap.appendChild(button);
      }

      function updateButton() {
        var canScroll = isDesktop() && holder.scrollWidth > holder.clientWidth + 2;
        var isAtEnd = holder.scrollLeft >= holder.scrollWidth - holder.clientWidth - 4;

        wrap.classList.toggle('laboo-thumbnail-scroll-ready', canScroll);
        button.hidden = !canScroll;
        button.classList.toggle('is-at-end', canScroll && isAtEnd);
      }

      if (button.dataset.labooThumbnailReady !== 'true') {
        button.dataset.labooThumbnailReady = 'true';

        button.addEventListener('click', function () {
          var thumbnail = holder.querySelector('.thumbnail');
          var step = thumbnail ? thumbnail.getBoundingClientRect().width : 70;

          holder.scrollBy({
            left: Math.max(step * 3, 180),
            behavior: 'smooth'
          });
        });

        holder.addEventListener('scroll', function () {
          window.requestAnimationFrame(updateButton);
        }, { passive: true });

        window.addEventListener('resize', function () {
          window.requestAnimationFrame(updateButton);
        });
      }

      updateButton();
      window.setTimeout(updateButton, 300);
      window.setTimeout(updateButton, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initThumbnailChevron(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initThumbnailChevron(event.target);
  });

  window.addEventListener('load', function () {
    initThumbnailChevron(document);
  });

  window.setTimeout(function () {
    initThumbnailChevron(document);
  }, 800);

  window.setTimeout(function () {
    initThumbnailChevron(document);
  }, 2400);
})();

// Laboo 2026: make the product-page review summary scroll to reviews.
(function () {
  const badgeSelector = 'body.template-product .product-review-badge .jdgm-prev-badge';

  function getReviewTarget() {
    const targets = Array.from(document.querySelectorAll('.product-bottom-reviews--carousel, #judgeme_product_reviews'));

    return targets.find(function (element) {
      return element.offsetParent !== null;
    }) || targets[0];
  }

  function scrollToReviews() {
    const target = getReviewTarget();

    if (!target) {
      return;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Product recommendations and other sections load lazily above the reviews,
    // which pushes the reviews down after the first scroll. Re-anchor once the
    // layout has settled so the reviews still end up in view.
    window.setTimeout(function () {
      const settled = getReviewTarget();

      if (settled) {
        settled.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 700);
  }

  function openReviews(event) {
    event.preventDefault();
    scrollToReviews();
  }

  function onBadgeKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    openReviews(event);
  }

  function enhanceReviewBadges() {
    document.querySelectorAll(badgeSelector).forEach(function (badge) {
      if (badge.dataset.labooReviewLinkReady === 'true') {
        return;
      }

      badge.dataset.labooReviewLinkReady = 'true';
      badge.setAttribute('role', 'link');
      badge.setAttribute('tabindex', '0');
      badge.setAttribute('aria-label', 'View reviews');
      badge.addEventListener('click', openReviews);
      badge.addEventListener('keydown', onBadgeKeydown);
    });
  }

  document.addEventListener('DOMContentLoaded', enhanceReviewBadges);
  document.addEventListener('shopify:section:load', enhanceReviewBadges);
  window.addEventListener('load', enhanceReviewBadges);
  window.setTimeout(enhanceReviewBadges, 1200);
})();

// Laboo 2026: keep US-only size selectors in the approved inch-size order.
(function () {
  function getSizeOrder(element) {
    const order = Number(element.getAttribute('data-laboo-us-size-order') || element.getAttribute('data-p-us-size-order') || 999);
    return Number.isFinite(order) ? order : 999;
  }

  function sortSizeSelect(select) {
    if (select.dataset.labooUsSizeSorted === 'true') {
      return;
    }

    const options = Array.from(select.querySelectorAll('option[data-laboo-us-size-order]'));

    if (!options.some(option => option.getAttribute('data-laboo-us-size-order'))) {
      return;
    }

    options
      .sort((firstOption, secondOption) => getSizeOrder(firstOption) - getSizeOrder(secondOption))
      .forEach(option => select.appendChild(option));

    select.dataset.labooUsSizeSorted = 'true';
  }

  function sortSizeOptionGroup(group) {
    if (group.dataset.labooUsSizeSorted === 'true') {
      return;
    }

    const items = Array.from(group.children).filter(child => (
      child.hasAttribute('data-laboo-us-size-order') || child.hasAttribute('data-p-us-size-order')
    ));

    if (!items.some(item => item.getAttribute('data-laboo-us-size-order') || item.getAttribute('data-p-us-size-order'))) {
      return;
    }

    items
      .sort((firstItem, secondItem) => getSizeOrder(firstItem) - getSizeOrder(secondItem))
      .forEach(item => group.appendChild(item));

    group.dataset.labooUsSizeSorted = 'true';
  }

  function initLabooUsSizeOrdering() {
    document.querySelectorAll('select').forEach(sortSizeSelect);

    document.querySelectorAll('.product-variant__container, .product-variant__options, .sidebar-variants-wrap').forEach(sortSizeOptionGroup);
  }

  document.addEventListener('DOMContentLoaded', initLabooUsSizeOrdering);
  document.addEventListener('shopify:section:load', initLabooUsSizeOrdering);
  window.addEventListener('load', initLabooUsSizeOrdering);
})();

// Laboo 2026: mobile product accordions use a single, smooth, no-scroll-jump controller.
(function () {
  const accordionSelector = 'body.template-product product-page .product-info-col .p-collapse-wrap.mobile-tabs';
  const titleSelector = 'toggle-tab.toggle > [data-js-title]';
  const contentSelector = '[data-js-content]';
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  function setContentHeight(toggle, height) {
    const content = toggle && toggle.querySelector(contentSelector);

    if (!content) {
      return;
    }

    content.style.maxHeight = height;
  }

  function closeToggle(toggle) {
    if (!toggle || !toggle.classList.contains('opened')) {
      return;
    }

    const title = toggle.querySelector('[data-js-title]');
    const content = toggle.querySelector(contentSelector);

    if (content) {
      content.style.maxHeight = `${content.scrollHeight}px`;
      content.offsetHeight;
    }

    toggle.classList.remove('opened');

    if (title) {
      title.setAttribute('aria-expanded', 'false');
    }

    setContentHeight(toggle, '0px');
  }

  function openToggle(toggle) {
    if (!toggle || toggle.classList.contains('opened')) {
      return;
    }

    const accordion = toggle.closest(accordionSelector);
    const title = toggle.querySelector('[data-js-title]');
    const content = toggle.querySelector(contentSelector);

    if (accordion) {
      accordion.querySelectorAll('toggle-tab.toggle.opened').forEach(function (openSibling) {
        if (openSibling !== toggle) {
          closeToggle(openSibling);
        }
      });
    }

    toggle.classList.add('opened');

    if (title) {
      title.setAttribute('aria-expanded', 'true');
    }

    if (content) {
      content.style.maxHeight = `${content.scrollHeight}px`;
    }
  }

  function togglePanel(toggle) {
    if (!toggle) {
      return;
    }

    if (toggle.classList.contains('opened')) {
      closeToggle(toggle);
    } else {
      openToggle(toggle);
      keepOpenedToggleTitleVisible(toggle);
    }
  }

  function getStickyTopOffset() {
    const selectors = [
      '.shopify-section-group-header-group.mount-announcement-bar',
      '.laboo-offer-strip-shell',
      'main-header',
      '#site-header',
      '.shopify-section-group-header-group.mount-header'
    ];

    let offset = 8;
    const seen = new Set();

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        if (seen.has(element)) {
          return;
        }

        seen.add(element);

        const styles = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();

        if ((styles.position === 'fixed' || styles.position === 'sticky') && rect.top <= offset + 2 && rect.bottom > 0) {
          offset += rect.height;
        }
      });
    });

    return Math.min(offset, 160);
  }

  function scrollToggleTitleIntoView(toggle) {
    if (!mobileQuery.matches || !toggle || !toggle.classList.contains('opened')) {
      return;
    }

    const title = toggle.querySelector('[data-js-title]');

    if (!title) {
      return;
    }

    const titleTop = title.getBoundingClientRect().top;
    const desiredTop = getStickyTopOffset();
    const targetY = window.pageYOffset + titleTop - desiredTop;

    if (Math.abs(titleTop - desiredTop) > 6) {
      window.scrollTo({
        top: Math.max(0, targetY),
        behavior: 'smooth'
      });
    }
  }

  function keepOpenedToggleTitleVisible(toggle) {
    window.requestAnimationFrame(function () {
      scrollToggleTitleIntoView(toggle);
    });

    window.setTimeout(function () {
      scrollToggleTitleIntoView(toggle);
    }, 320);
  }

  function syncHeights(accordion) {
    accordion.querySelectorAll('toggle-tab.toggle').forEach(function (toggle) {
      const title = toggle.querySelector('[data-js-title]');
      const content = toggle.querySelector(contentSelector);

      if (title) {
        title.setAttribute('aria-expanded', toggle.classList.contains('opened') ? 'true' : 'false');
      }

      if (!content) {
        return;
      }

      if (mobileQuery.matches) {
        content.style.maxHeight = toggle.classList.contains('opened') ? `${content.scrollHeight}px` : '0px';
      } else {
        content.style.maxHeight = '';
      }
    });
  }

  function initProductAccordionGroup(accordion) {
    if (accordion.dataset.labooSmoothAccordionReady === 'true') {
      syncHeights(accordion);
      return;
    }

    accordion.dataset.labooSmoothAccordionReady = 'true';
    syncHeights(accordion);

    accordion.addEventListener('click', function (event) {
      if (!mobileQuery.matches) {
        return;
      }

      const title = event.target.closest(titleSelector);

      if (!title || !accordion.contains(title)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      togglePanel(title.closest('toggle-tab.toggle'));
    }, true);

    accordion.addEventListener('keydown', function (event) {
      if (!mobileQuery.matches || (event.key !== 'Enter' && event.key !== ' ')) {
        return;
      }

      const title = event.target.closest(titleSelector);

      if (!title || !accordion.contains(title)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      togglePanel(title.closest('toggle-tab.toggle'));
    }, true);
  }

  function initProductAccordions() {
    document.querySelectorAll(accordionSelector).forEach(initProductAccordionGroup);
  }

  document.addEventListener('DOMContentLoaded', initProductAccordions);
  document.addEventListener('shopify:section:load', initProductAccordions);
  window.addEventListener('load', initProductAccordions);
  window.addEventListener('resize', initProductAccordions);
  window.setTimeout(initProductAccordions, 1200);
})();

// Laboo 2026: clamp long product review carousel text to four lines with an inline More control.
(function () {
  const bodySelector = 'body.template-product .product-bottom-reviews--carousel .jdgm-carousel-item__review-body';

  function hasOverflow(element) {
    return element.scrollHeight > element.clientHeight + 2;
  }

  function updateMoreButton(body, button) {
    const expanded = body.classList.contains('laboo-review-expanded');
    const labels = (window.LabooI18n && window.LabooI18n.reviews) || {};
    button.textContent = expanded ? (labels.less || 'Less') : (labels.more || 'More');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function enhanceReviewBody(body) {
    if (body.dataset.labooReviewClampReady === 'true') {
      const existingButton = body.querySelector('.laboo-review-more-button');

      if (existingButton && !body.classList.contains('laboo-review-expanded')) {
        existingButton.classList.toggle('is-visible', hasOverflow(body));
      }

      return;
    }

    body.dataset.labooReviewClampReady = 'true';

    window.requestAnimationFrame(function () {
      if (!hasOverflow(body)) {
        return;
      }

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'laboo-review-more-button is-visible';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = ((window.LabooI18n && window.LabooI18n.reviews && window.LabooI18n.reviews.more) || 'More');

      button.addEventListener('click', function () {
        body.classList.toggle('laboo-review-expanded');
        updateMoreButton(body, button);
      });

      body.appendChild(button);
    });
  }

  function initReviewClamps() {
    document.querySelectorAll(bodySelector).forEach(enhanceReviewBody);
  }

  document.addEventListener('DOMContentLoaded', initReviewClamps);
  document.addEventListener('shopify:section:load', initReviewClamps);
  window.addEventListener('load', initReviewClamps);
  window.setTimeout(initReviewClamps, 1000);
  window.setTimeout(initReviewClamps, 2600);
})();

// Laboo 2026: keep the offer bar and main menu sticky as one measured stack.
(function () {
  const root = document.documentElement;
  let mutationObserver;
  let resizeObserver;
  let updateFrame;

  function queryFirst(selectors) {
    for (let i = 0; i < selectors.length; i += 1) {
      const element = document.querySelector(selectors[i]);
      if (element) {
        return element;
      }
    }

    return null;
  }

  function getStickyElements() {
    return {
      offer: queryFirst([
        '.laboo-offer-strip-shell',
        '.shopify-section.shopify-section-group-header-group.mount-announcement-bar',
        '.shopify-section-group-header-group.mount-announcement-bar'
      ]),
      header: queryFirst([
        '.shopify-section.shopify-section-group-header-group.site-header-container.mount-header',
        '.shopify-section-group-header-group.site-header-container.mount-header',
        '.shopify-section-group-header-group.mount-header',
        '.site-header-container.mount-header',
        '#shopify-section-header',
        'main-header#site-header'
      ])
    };
  }

  function elementHeight(element) {
    if (!element) {
      return 0;
    }

    return Math.ceil(element.getBoundingClientRect().height || element.offsetHeight || 0);
  }

  function updateStickyStack() {
    if (!document.body) {
      return;
    }

    const elements = getStickyElements();

    if (!elements.header) {
      document.body.classList.remove('laboo-sticky-bars-ready');
      return;
    }

    root.style.setProperty('--laboo-offer-bar-height', `${elementHeight(elements.offer)}px`);
    root.style.setProperty('--laboo-header-height', `${elementHeight(elements.header)}px`);
    document.body.classList.add('laboo-sticky-bars-ready');
  }

  function scheduleStickyStack() {
    if (updateFrame) {
      return;
    }

    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = null;
      updateStickyStack();
      observeStickyStack();
    });
  }

  function observeStickyStack() {
    if (!window.ResizeObserver) {
      return;
    }

    const elements = getStickyElements();
    if (!elements.header) {
      return;
    }

    if (resizeObserver) {
      resizeObserver.disconnect();
    }

    resizeObserver = new ResizeObserver(scheduleStickyStack);
    resizeObserver.observe(elements.header);

    if (elements.offer) {
      resizeObserver.observe(elements.offer);
    }
  }

  function observeHeaderMounts() {
    if (!window.MutationObserver || mutationObserver) {
      return;
    }

    mutationObserver = new MutationObserver(scheduleStickyStack);
    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function initStickyStack() {
    observeHeaderMounts();
    scheduleStickyStack();
  }

  document.addEventListener('DOMContentLoaded', initStickyStack);
  document.addEventListener('shopify:section:load', initStickyStack);
  window.addEventListener('load', initStickyStack);
  window.addEventListener('resize', scheduleStickyStack);
  window.setTimeout(initStickyStack, 50);
  window.setTimeout(initStickyStack, 250);
  window.setTimeout(initStickyStack, 600);
  window.setTimeout(initStickyStack, 1400);
})();

// Laboo 2026: mobile product-card image swipe progress.
(function () {
  const carouselSelector = '[data-laboo-card-carousel]';
  const trackSelector = '[data-laboo-card-carousel-track]';
  const slideSelector = '[data-laboo-card-carousel-slide]';
  let mutationFrame = null;

  function updateCarouselProgress(carousel) {
    const track = carousel.querySelector(trackSelector);

    if (!track) {
      return;
    }

    // 30 Oct 2026: any number of photos (was 2); the bar is 1/count wide and moves to the photo in view
    const count = Math.max(1, carousel.querySelectorAll(slideSelector).length);
    const index = track.clientWidth > 0 ? Math.min(count - 1, Math.round(track.scrollLeft / track.clientWidth)) : 0;
    carousel.style.setProperty('--laboo-card-carousel-count', count);
    carousel.style.setProperty('--laboo-card-carousel-index', index);
  }

  function initCardCarousel(carousel) {
    if (!carousel || carousel.dataset.labooCardCarouselReady === 'true') {
      return;
    }

    const track = carousel.querySelector(trackSelector);
    const slides = carousel.querySelectorAll(slideSelector);

    if (!track || slides.length < 2) {
      return;
    }

    carousel.dataset.labooCardCarouselReady = 'true';

    let scrollFrame = null;
    let startX = 0;
    let startY = 0;
    let suppressClick = false;

    function requestProgressUpdate() {
      if (scrollFrame) {
        return;
      }

      scrollFrame = window.requestAnimationFrame(function () {
        scrollFrame = null;
        updateCarouselProgress(carousel);
      });
    }

    function storeStartPoint(clientX, clientY) {
      startX = clientX;
      startY = clientY;
      suppressClick = false;
    }

    function watchMovement(clientX, clientY) {
      const deltaX = Math.abs(clientX - startX);
      const deltaY = Math.abs(clientY - startY);

      if (deltaX > 8 && deltaX > deltaY) {
        suppressClick = true;
      }
    }

    track.addEventListener('scroll', requestProgressUpdate, { passive: true });

    track.addEventListener('touchstart', function (event) {
      if (!event.touches.length) {
        return;
      }

      storeStartPoint(event.touches[0].clientX, event.touches[0].clientY);
    }, { passive: true });

    track.addEventListener('touchmove', function (event) {
      if (!event.touches.length) {
        return;
      }

      watchMovement(event.touches[0].clientX, event.touches[0].clientY);
    }, { passive: true });

    track.addEventListener('touchend', function () {
      window.setTimeout(function () {
        suppressClick = false;
      }, 450);
    }, { passive: true });

    track.addEventListener('mousedown', function (event) {
      storeStartPoint(event.clientX, event.clientY);
    });

    track.addEventListener('mousemove', function (event) {
      watchMovement(event.clientX, event.clientY);
    });

    track.addEventListener('click', function (event) {
      if (!suppressClick) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    updateCarouselProgress(carousel);
  }

  function initCardCarousels(root) {
    const scope = root || document;

    if (scope.matches && scope.matches(carouselSelector)) {
      initCardCarousel(scope);
    }

    scope.querySelectorAll(carouselSelector).forEach(initCardCarousel);
  }

  function scheduleInit(root) {
    if (mutationFrame) {
      return;
    }

    mutationFrame = window.requestAnimationFrame(function () {
      mutationFrame = null;
      initCardCarousels(root || document);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCardCarousels(document);

    if (!window.MutationObserver) {
      return;
    }

    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) {
            continue;
          }

          if ((node.matches && node.matches(carouselSelector)) || (node.querySelector && node.querySelector(carouselSelector))) {
            scheduleInit(document);
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCardCarousels(event.target);
  });

  window.addEventListener('load', function () {
    initCardCarousels(document);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll(carouselSelector).forEach(updateCarouselProgress);
  });

  window.LabooInitCardCarousels = initCardCarousels;
})();
